import React from "react";
const NotFound = () => {
  return (
    <div className="container">
      <code>http request failed with a status: 404</code>
    </div>
  );
};

export default NotFound;
